import { Firestore } from '../Firebase';
import { produtos, categorias, promocoes, banners, espacos } from '../store/store.js';

const stringToSlug = (str) => {
  str = str.replace(/^\s+|\s+$/g, ''); // trim
  str = str.toLowerCase();

  // remove accents, swap ñ for n, etc
  var from = "àáäãâèéëêìíïîòóöôùúüûñç·/_,:;";
  var to   = "aaaaaeeeeiiiioooouuuunc------";
  for (var i=0, l=from.length ; i<l ; i++) {
      str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
      .replace(/\s+/g, '-') // collapse whitespace and replace by -
      .replace(/-+/g, '-'); // collapse dashes

  return str;
}

const criaProduto = async produto => {
  const categoriaSlug = stringToSlug(produto.categoria);
  const slug = stringToSlug(produto.nome);

  return Firestore.collection("produtos")
    .add(
      {
        ...produto,
        categoriaSlug,
        slug,
        createdAt: Date.now() 
      }
    );
}

const listaProdutos = async () => {
  Firestore
    .collection("produtos")
    .orderBy("createdAt", "desc")
    .get()
    .then(function(snap) {
      let list = [];
      snap.forEach(
        doc => list.push(
          {
            id: doc.id,
            ...doc.data()
          }
        )
      );
      produtos.set(list);
    }
  );
}

const procuraProdutos = async (nome) => {
  return Firestore
    .collection("produtos")
    .orderBy("nome", "asc")
    .startAt(nome)
    .endAt(nome + "\uf8ff")
    .get()
    .then(function(snap) {
      let list = [];
      snap.forEach(
        doc => list.push(
          {
            id: doc.id,
            ...doc.data()
          }
        )
      );
      return list;
    }
  );
}

const carregaProduto = async id => {
  try {
    return Firestore.collection("produtos").doc(id).get().then(
      doc => {
        return {
          id: doc.id,
          ...doc.data()
        }
      }
    )
  } catch (error) {
    console.log(error)
  }
}

const editaProduto = async produto => {
  try {
    const categoriaSlug = stringToSlug(produto.categoria);
    const slug = stringToSlug(produto.nome);

    return Firestore.collection("produtos")
      .doc(produto.id)
      .update(
        {
          ...produto,
          categoriaSlug,
          slug
        }
      );
  } catch (error) {
    throw error;
  }
}

const criaCategoria = async categoria => {
  const slug = stringToSlug(categoria.nome);

  return Firestore.collection("categorias")
    .add(
      {
        slug,
        ...categoria,
        createdAt: Date.now() 
      }
    );
}

const listaCategorias = async () => {
  Firestore
    .collection("categorias")
    .orderBy("nome", "asc")
    .get()
    .then(function(snap) {
      let list = [];
      snap.forEach(
        doc => list.push(
          {
            id: doc.id,
            ...doc.data()
          }
        )
      );
      categorias.set(list);
    }
  );
}

const carregaCategoria = async id => {
  try {
    return Firestore.collection("categorias").doc(id).get().then(
      doc => {
        return {
          id: doc.id,
          ...doc.data()
        }
      }
    )
  } catch (error) {
    console.log(error)
  }
}

const editaCategoria = async categoria => {
  try {
    const slug = stringToSlug(categoria.nome);

    return Firestore.collection("categorias")
      .doc(categoria.id)
      .update(
        {
          ...categoria,
          slug
        }
      );
  } catch (error) {
    throw error;
  }
}

const deletaCategoria = async categoria => {
  try {
    return Firestore.collection("categorias")
      .doc(categoria.id)
      .delete();
  } catch (error) {
    throw error;
  }
}


const criaPromocao = async promocao => {
  const slug = stringToSlug(promocao.nome);

  return Firestore.collection("promocoes")
    .add(
      {
        slug,
        ...promocao,
        createdAt: Date.now() 
      }
    );
}

const listaPromocoes = async () => {
  Firestore
    .collection("promocoes")
    .orderBy("nome", "asc")
    .get()
    .then(function(snap) {
      let list = [];
      snap.forEach(
        doc => list.push(
          {
            id: doc.id,
            ...doc.data()
          }
        )
      );
      promocoes.set(list);
    }
  );
}

const carregaPromocao = async id => {
  try {
    return Firestore.collection("promocoes").doc(id).get().then(
      doc => {
        return {
          id: doc.id,
          ...doc.data()
        }
      }
    )
  } catch (error) {
    console.log(error)
  }
}

const editaPromocao = async promocao => {
  try {
    const slug = stringToSlug(promocao.nome);

    return Firestore.collection("promocoes")
      .doc(promocao.id)
      .update(
        {
          ...promocao,
          slug
        }
      );
  } catch (error) {
    throw error;
  }
}

const deletaPromocao = async promocao => {
  try {
    return Firestore.collection("promocoes")
      .doc(promocao.id)
      .delete();
  } catch (error) {
    throw error;
  }
}

const criaBanner = async banner => {
  return Firestore.collection("banners")
    .add(
      {
        ...banner,
        createdAt: Date.now() 
      }
    );
}

const listaBanners = async () => {
  Firestore
    .collection("banners")
    .orderBy("createdAt", "asc")
    .get()
    .then(function(snap) {
      let list = [];
      snap.forEach(
        doc => list.push(
          {
            id: doc.id,
            ...doc.data()
          }
        )
      );
      banners.set(list);
    }
  );
}


const carregaBanner = async id => {
  try {
    return Firestore.collection("banners").doc(id).get().then(
      doc => {
        return {
          id: doc.id,
          ...doc.data()
        }
      }
    )
  } catch (error) {
    console.log(error)
  }
}

const editaBanner = async banner => {
  try {
    return Firestore.collection("banners")
      .doc(banner.id)
      .update(
        {
          ...banner
        }
      );
  } catch (error) {
    throw error;
  }
}

const deletaBanner = async banner => {
  try {
    return Firestore.collection("banners")
      .doc(banner.id)
      .delete();
  } catch (error) {
    throw error;
  }
}

const criaEspaco = async espaco => {
  return Firestore.collection("espacos")
    .add(
      {
        ...espaco,
        createdAt: Date.now()
      }
    );
}

const listaEspacos = async () => {
  Firestore
    .collection("espacos")
    .orderBy("createdAt", "desc")
    .get()
    .then(function(snap) {
      let list = [];
      snap.forEach(
        doc => list.push(
          {
            id: doc.id,
            ...doc.data()
          }
        )
      );
      espacos.set(list);
    }
  );
}

const carregaEspaco = async id => {
  try {
    return Firestore.collection("espacos").doc(id).get().then(
      doc => {
        return {
          id: doc.id,
          ...doc.data()
        }
      }
    )
  } catch (error) {
    console.log(error)
  }
}

const editaEspaco = async espaco => {
  try {
    return Firestore.collection("espacos")
      .doc(espaco.id)
      .update(
        {
          ...espaco
        }
      );
  } catch (error) {
    throw error;
  }
}

const deletaEspaco = async espaco => {
  try {
    return Firestore.collection("espacos")
      .doc(espaco.id)
      .delete();
  } catch (error) {
    throw error;
  }
}

export {
  criaProduto,
  listaProdutos,
  procuraProdutos,
  carregaProduto,
  editaProduto,
  criaCategoria,
  listaCategorias,
  carregaCategoria,
  editaCategoria,
  deletaCategoria,
  criaPromocao,
  listaPromocoes,
  carregaPromocao,
  editaPromocao,
  deletaPromocao,
  criaBanner,
  listaBanners,
  carregaBanner,
  editaBanner,
  deletaBanner,
  criaEspaco,
  listaEspacos,
  carregaEspaco,
  editaEspaco,
  deletaEspaco
};